import styled from 'styled-components'

import { color, fontFamily } from 'src/styles'

type InputProps = {
  isError?: boolean
}

export const StyledInput = styled.input<InputProps>`
  width: 100%;
  height: 4.8rem;
  border-radius: 0.6rem;
  background-color: ${color.VERY_LIGHT_PINK};
  border: solid 0.1rem
    ${({ isError }) => (isError ? `${color.ORANGEY_RED}` : `${color.WHITE}`)};
  padding-left: 1.6rem;
  font-size: 1.6rem;
  line-height: 4.8rem;
  color: ${color.GREYISH_BROWN};
  font-family: ${fontFamily.CATAMARAN};
  -webkit-appearance: none;

  ::placeholder {
    font-size: 1.6rem;
    color: ${color.PUTTY};
  }
`
